import { render, staticRenderFns } from "./TappayPayment.vue?vue&type=template&id=04df5f64&scoped=true"
import script from "./TappayPayment.vue?vue&type=script&lang=js"
export * from "./TappayPayment.vue?vue&type=script&lang=js"
import style0 from "./TappayPayment.vue?vue&type=style&index=0&id=04df5f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df5f64",
  null
  
)

export default component.exports